module.exports = __webpack_public_path__ + "static/img/idea.9e2f00b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/idea.jpg
// module id = feVY
// module chunks = 1